import styled from 'styled-components';

export const WidgetBodyLong = styled.div`
  position: relative;
  width: 100%;
  height: 0;
  padding-top: calc(100% / 6.78);
  overflow: hidden;
`;
